export { default as ctaRowWithBrushstrokeAdapter } from './adapter';
export { default as CtaRowWithBrushstroke } from './CtaRowWithBrushstroke';
